import { isPresent } from '@luminovo/commons';

export type TaricComponent =
    | 'hs-sub-heading'
    | 'cn-sub-heading'
    | 'taric-sub-heading'
    | 'national-code'
    | 'additional-taric-code';
export type TaricCodeResult =
    | { type: 'full'; formattedCode: string }
    | {
          type: 'partial';
          formattedCode: string;
          component: TaricComponent;
      }
    | { type: 'invalid' };

const TARIC_REGEX =
    /^(?<chapter>\d{2})(?<hs_heading>\d{2})(?<hs_sub_heading>\d{2})(?<cn_sub_heading>\d{2})?(?<taric_sub_heading>\d{2})?(?<national_code>\d)?(?<additional_taric_code>\d{4})?$/;

export function parseTaricCode(code: string | null | undefined): TaricCodeResult {
    if (!isPresent(code)) {
        return { type: 'invalid' };
    }

    const trimmedCode = code.trim();

    const result = trimmedCode.match(TARIC_REGEX);
    if (!isPresent(result)) {
        return { type: 'invalid' };
    }

    const groups = result.groups;
    if (!isPresent(groups)) {
        return { type: 'invalid' };
    }

    const hsChapter = groups['chapter'];
    const hsHeading = groups['hs_heading'];
    const hsSubHeading = groups['hs_sub_heading'];
    const cnSubHeading = groups['cn_sub_heading'];
    const taricSubHeading = groups['taric_sub_heading'];
    const nationalCode = groups['national_code'];
    const additionalTaricCode = groups['additional_taric_code'];

    return getTaricCodeResult({
        hsChapter,
        hsHeading,
        hsSubHeading,
        cnSubHeading,
        taricSubHeading,
        nationalCode,
        additionalTaricCode,
    });
}

type TaricCode = {
    hsChapter: string;
    hsHeading: string;
    hsSubHeading: string;
    cnSubHeading: string | undefined;
    taricSubHeading: string | undefined;
    nationalCode: string | undefined;
    additionalTaricCode: string | undefined;
};

function getTaricCodeResult(taricCode: TaricCode): TaricCodeResult {
    const { hsChapter, hsHeading, hsSubHeading, cnSubHeading, taricSubHeading, nationalCode, additionalTaricCode } =
        taricCode;
    let component: TaricComponent = 'hs-sub-heading';

    let code = `${hsChapter}${hsHeading}${hsSubHeading}`;

    if (isPresent(cnSubHeading)) {
        code = `${code}${cnSubHeading}`;
        component = 'cn-sub-heading';
    }

    if (isPresent(taricSubHeading)) {
        code = `${code}${taricSubHeading}`;
        component = 'taric-sub-heading';
    }

    if (isPresent(nationalCode)) {
        code = `${code}${nationalCode}`;
        component = 'national-code';
    }

    if (isPresent(additionalTaricCode)) {
        code = `${code}${additionalTaricCode}`;
        component = 'additional-taric-code';
    }

    if (['taric-sub-heading', 'national_code', 'additional-taric-code'].includes(component)) {
        return { type: 'full', formattedCode: code };
    }

    return {
        type: 'partial',
        component,
        formattedCode: code,
    };
}
